import { FaFacebookF, FaInstagram, FaYoutube } from 'react-icons/fa';
import { IconContext } from 'react-icons';
import { NavLink } from 'react-router-dom';

export const Footer = () => {
  const currentYear = new Date().getFullYear();
// Ajoutez cette fonction dans votre composant Footer
const handleSmoothScroll = (e: React.MouseEvent<HTMLAnchorElement>, to: string) => {
  if (to.includes('#') && to !== '#') {
    const id = to.replace('/#', '');
    const element = document.getElementById(id);

    if (element) {
      e.preventDefault();
      const headerHeight = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - headerHeight;
      window.scrollTo({ top: offsetPosition, behavior: 'smooth' });
    }
    // Si l'élément n'existe pas (on est sur une autre page), React Router navigue normalement vers /#about etc.
  }
};
  return (
    <footer className="bg-[#16161e] text-gray-300">
      <div className="max-w-7xl mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-8">
          {/* Logo et Description */}
          <div className="text-center md:text-left">
            <h2 className="text-2xl font-serif mb-4 text-white">
              𝓨𝓸𝓱𝓪𝓷𝓥𝓲𝓼𝓲𝓸𝓷
            </h2>
            <p className="text-sm text-gray-400">
              Capturant vos moments précieux avec passion et créativité
            </p>
          </div>

          {/* Navigation */}
          <nav className="text-center">
            <h3 className="text-lg font-semibold mb-4 text-white">Navigation</h3>
            <ul className="space-y-2">
              {[
                      { to: "/", label: "Accueil" },
                      { to: "/#about", label: "À propos" },
                      { to: "/#portfolio", label: "Portfolio" },
                      { to: "/#contact", label: "Contactez-nous" }
              ].map((link) => (
                <li key={link.to}>
                  <NavLink
  to={link.to}
  onClick={(e) => handleSmoothScroll(e, link.to)}
  className="hover:text-white transition-colors"
>
  {link.label}
</NavLink>
                </li>
              ))}
            </ul>
          </nav>

          {/* Réseaux Sociaux */}
          <div className="text-center md:text-right">
            <h3 className="text-lg font-semibold mb-4 text-white">Suivez-nous</h3>
            <div className="flex justify-center md:justify-end space-x-4">
              {[
                {
                  href: 'https://www.facebook.com/profile.php?id=100010381140256&locale=fr_CA',
                  icon: FaFacebookF,
                  label: 'Facebook',
                },
                {
                  href: 'https://www.instagram.com/yohan.p0v/',
                  icon: FaInstagram,
                  label: 'Instagram',
                },
                {
                  href: 'https://www.youtube.com/@yohan.p0v',
                  icon: FaYoutube,
                  label: 'YouTube',
                },
              ].map((social) => (
                <a
                  key={social.label}
                  href={social.href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:text-white transition-colors"
                  aria-label={social.label}
                >
                  <IconContext.Provider value={{ size: '1.5em' }}>
                    <social.icon />
                  </IconContext.Provider>
                </a>
              ))}
            </div>
          </div>
        </div>

        {/* Politique de confidentialité */}
        <div className="border-t border-gray-800 pt-6 pb-4 text-center text-sm">
          <div className="flex justify-center space-x-4 mb-4">
            <NavLink to="/politique/confidentialite" className="text-gray-400 hover:text-white transition-colors">
              Politique de confidentialité
            </NavLink>
        
          </div>
          <p className="text-gray-400">
            {currentYear} YohanVision INC. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};